import React from 'react';
import { QueryResult, useQuery } from '@apollo/client';
import {
  FetchRecentlyGeneratedInvoicesForHomePageInPpcQuery,
  FetchRecentlyGeneratedInvoicesForHomePageInPpcQueryVariables,
  InvoiceStatus,
  SortDirection,
} from '@css-xp/graphtypes/src/generated-types-new';
import { fetchRecentlyGeneratedInvoicesForHomePageInPPC } from './queries/fetch-recently-generated-invoices-for-home-page';
import { MAX_WIDGET_ITEMS } from '../../../constants/widget';

type ChildrenProp = (
  args: QueryResult<
    FetchRecentlyGeneratedInvoicesForHomePageInPpcQuery,
    FetchRecentlyGeneratedInvoicesForHomePageInPpcQueryVariables
  >
) => JSX.Element;

export const RecentlyGeneratedInvoicesQueryWrapper = ({
  txaId,
  children,
}: {
  txaId: string;
  children: ChildrenProp;
}): JSX.Element => {
  const queryResult = useQuery<
    FetchRecentlyGeneratedInvoicesForHomePageInPpcQuery,
    FetchRecentlyGeneratedInvoicesForHomePageInPpcQueryVariables
  >(fetchRecentlyGeneratedInvoicesForHomePageInPPC, {
    variables: {
      id: txaId,
      searchOptions: {
        first: MAX_WIDGET_ITEMS,
        sort: {
          sortFields: ['createdDate', 'id'],
          sortFieldsDirections: [SortDirection.DESC, SortDirection.DESC],
        },
      },
      filterOptions: {
        not: [{ status: InvoiceStatus.DRAFT }],
      },
    },
    skip: !txaId,
    fetchPolicy: 'cache-and-network',
  });
  return children(queryResult);
};
